// extracted by mini-css-extract-plugin
export var checkIcon = "commentForm-module--checkIcon--a537b";
export var checkLabel = "commentForm-module--checkLabel--3c5c5";
export var checkbox = "commentForm-module--checkbox--8b119";
export var error = "commentForm-module--error--e4d34";
export var form = "commentForm-module--form--6e1e6";
export var msg = "commentForm-module--msg--72aef";
export var msgError = "commentForm-module--msgError--f0564";
export var rating = "commentForm-module--rating--7f5df";
export var ratingText = "commentForm-module--rating-text--cb028";
export var textarea = "commentForm-module--textarea--85e90";
export var valid = "commentForm-module--valid--83317";